/* Built In Imports */
import React from 'react';
/* External Imports */
import { Box, Center, Text } from '@chakra-ui/react';

/* Internal Imports */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';
/* Components */

/* Services */
/**
 * MomQuote Component
 * @param {Object} section dato
 * @param {String} region
 * @param {String} lang
 * @returns {ReactElement} MomQuote Component
 */

const MomQuote = ({ section, region, lang }) => {
  const quote = section.find(el => el?._modelApiKey === 'quote');
  return (
    <Box w="100%" height="100%" mb="30px">
      <Box w="100%" bg="#f6f6f6" py={{ base: '32px', md: '70px' }} px="16px">
        <Center flexDir="column" maxW="530px" mx="auto">
          <LazyLoadImageComponent
            src={`${config.imgPath}/d/46272/1731050949-format_quote.png`}
          />
          <Text
            fontFamily="'Trirong', serif"
            textAlign="center"
            fontSize={{ base: '18px', md: '2.5rem' }}
            m={{ base: '20px', md: '60px 0 20px 0' }}
            lineHeight={{ base: '27px', md: '48px' }}
          >
            {quote.quote}
          </Text>
          <LazyLoadImageComponent
            mt={{ base: '20px' }}
            src={`${config.imgPath}/d/46272/1731050948-sadhguru-signature.png`}
            alt="sadhguru's signature"
            h={{ base: '52px', lg: '75px' }}
            w={{ base: '110px', md: '160px' }}
          />
        </Center>
      </Box>
    </Box>
  );
};

export default MomQuote;
